/* eslint-disable max-len */
import { AllieIconProps } from '../../../components';

export const MenuReportsSolidIcon: React.FC<AllieIconProps> = ({ size = 'large' }) => (
  <svg
    className="fill-icon"
    width={size === 'small' ? 16 : 20}
    height={size === 'small' ? 16 : 20}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect x="16" y="3" width="5" height="18" rx="2" fill="currentColor" />
    <rect x="9.5" y="9" width="5" height="12" rx="2" fill="currentColor" />
    <rect x="3" y="16" width="5" height="5" rx="2" fill="currentColor" />
  </svg>
);
